export default "__VITE_ASSET__CJLpnozk__"